import Http from "./http";

export const triggerWelcomeEmailAPI = (data) => {
    return Http.post("admin/triggerWelcomeNotification", data);
};
